import React from 'react';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import RoleManagement from 'components/RoleManagement';
import ProtectedRoute from 'components/ProtectedRoute';

export default function RoleManagementView() {
  return (
    <AdminPageShell title="Roles y permisos">
      <ProtectedRoute requiredPermissions={['roles.view']}>
        <RoleManagement />
      </ProtectedRoute>
    </AdminPageShell>
  );
}
